import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/vercel/path0/apps/web/src/app/(auth)/forgot-password/forgot-password-form.tsx");
